// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".points-table[data-v-10ef6bce]{border:1px solid #455fed;border-radius:.7rem;margin-top:.5rem;max-width:13rem;padding:.5rem 1rem}.points-to-charge[data-v-10ef6bce]{color:#455fed;font-size:1.2rem;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
